module.exports = __webpack_public_path__ + "media/smile-4.4460bcae.mp3";